export const checkIsOpenStatus = (openTime?: string | null, closeTime?: string | null) => {
  if (!openTime || !closeTime) return false;

  const now = new Date();
  const moscowOffset = 3;
  const moscowHours = now.getUTCHours() + moscowOffset;
  const moscowMinutes = now.getUTCMinutes();

  const current = {
    hours: moscowHours % 24,
    minutes: moscowMinutes,
  };

  const parseTime = (timeStr: string) => {
    const [hours, minutes] = timeStr.split(':').map(Number);
    return { hours, minutes };
  };

  const open = parseTime(openTime);
  const close = parseTime(closeTime);

  const toMinutes = (time: { hours: number; minutes: number }) => time.hours * 60 + time.minutes;

  const currentMinutes = toMinutes(current);
  const openMinutes = toMinutes(open);
  const closeMinutes = toMinutes(close);

  if (closeMinutes > openMinutes) {
    return currentMinutes >= openMinutes && currentMinutes < closeMinutes;
  } else {
    return currentMinutes >= openMinutes || currentMinutes < closeMinutes;
  }
};